import { Typography } from '@rbilabs/universal-components';
import { View } from 'react-native';

import { t } from 'state/intl/translations';

interface IQuestCardPendingOrdersMessage {
  totalSteps: number;
  completedSteps: number;
}
export const QuestCardPendingOrdersMessage = ({
  totalSteps,
  completedSteps,
}: IQuestCardPendingOrdersMessage) => {
  const message = t('questCardPendingOrdersMessage', { totalSteps });

  return (
    <View style={{ padding: 10, flexDirection: 'row' }}>
      <Typography variant="headerOne">{completedSteps.toString()}</Typography>
      <Typography style={{ marginTop: 5 }} variant="copyTwo">
        {message}
      </Typography>
    </View>
  );
};
